import uiI18n from "../i18n";
import { useState, useEffect, useRef  } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import citiesAndDelegations from '../data/citiesAndDelegations.js';
import citiesCoordinates from '../data/delegationsCoordinates.js';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useTranslation } from 'react-i18next';
import { vacationTypeKey } from '../utils/vacationTypes';
import axios from 'axios';
import { FaSearch } from "react-icons/fa";
import { FaSearchLocation } from "react-icons/fa";
import { getAuth } from "firebase/auth";import ImageUpload from '../components/ImageUpload.jsx';
import { createVacation} from '../Services/biensService.jsx';

function CreatePartyRooms() {  
  
  const [price, setprice] = useState('0'); 
  const [offerWeek, setofferWeek] = useState('0');
  const [offerMonth, setofferMonth] = useState('0');
  const [offerday, setOfferDay] = useState('0');
  const [currentSection, setCurrentSection] = useState(1);
  const  auth = getAuth();
  const handlePriceChange  = (e) => {
    setprice(e.target.value);
  };
  
   const handleOfferWeekChange = (e) => {
    setofferWeek(e.target.value);
  }; 
  const handleOfferMonthChange = (e) => {
    setofferMonth(e.target.value);
  }; 
  const handleContinue = (event) => {
    event.preventDefault();

    if (currentSection < 8) {
      setCurrentSection(currentSection + 1);
    }
  };

  const handlePrevious = () => {
    if (currentSection > 1) {
      setCurrentSection(currentSection - 1);
    }
  };

  const [formData, setFormData] = useState({
    Libelle: "",
    Type: "rent",
    Bien: "",
    Parking: false,
    Chambres: 0,
    SallesBains: 0,
    geolocationEnabled: false,
    meuble: false,
    Latitude: 0,  // Default latitude
    Longitude: 0,  // Default longitude
    Ville: "",
    CodePostal: "",
    Pays: "Tunisie",
    Description: "",
    PrixReduit: 0,
    Prix: 0,
    UrlImages: "anonymous.png",
    Surface: 0,
    Offre: false,
    images: {},
    Delegation: "",
    Category: "Appartement",
    Adresse: "",
    Email: auth.currentUser.email,
    Tel: "",
    Camera: false,
    uid : auth.currentUser.uid, 
    name: auth.currentUser.displayName 
   });

  const {
    Libelle,
    Type,  
    Surface,  
    SallesBains,
    CodePostal,
    Parking,
    meuble,
    Kitchen,
    AC,
    Piscine,
    Garden,
    Barbecue,
    BeachAccess,
    workspace,
    Washer,
    Wifi,
    TV,
    Lits,
    Adresse,
    Description,
    Offre,
    Prix,
    PrixReduit,
    Latitude,
    Longitude,
    UrlImages,
    DateAjout,
    DateUpdate,
    Ville, 
    Delegation, 
    Category, 
    Uid, 
    Email, 
    MaxGuests, 
    Bien,
    Chambres, 
    geolocationEnabled,
    Pays,
    images,
    Tel,
    Camera
  } = formData;

  const [coordinates, setCoordinates] = useState({ lat: 34.802075, lng: 9.055876 }); // Default center
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [position, setPosition] = useState([33.8869, 9.5375]); // Tunisia coordinates
  const [zoom, setZoom] = useState(7);
  const [searchTerm, setSearchTerm] = useState('');
  const [boundingBox, setBoundingBox] = useState(null);
  const [voyageurs, setVoyageurs] = useState(0);
  const [lits, setLits] = useState(0);  
  const [chambres, setChambres] = useState(0);
  const [sallesDeBain, setSallesDeBain] = useState(0);
  const mapRef = useRef();
  const handleSearch = async (event) => {
    event.preventDefault();
    const apiKey = 'VRmCILl7btoL7iPckJ7NuMa2t4yyIiuTlF5fnKUqcO4';//  process.env.REACT_APP_HERE_API_KEY;
    const url = `https://geocode.search.hereapi.com/v1/geocode?q=${searchTerm}&in=countryCode:TUN&apiKey=${apiKey}`;
    try {
      const response = await axios.get(url);
       if (response.data.items.length > 0) {
        const location = response.data.items[0];
        const { lat, lng } = location.position;
        setPosition([lat, lng]);
        setZoom(13);
  
        if (location.mapView) {
          const { north, south, east, west } = location.mapView;
          setBoundingBox([[south, west], [north, east]]);
        }
      } else {
        alert(uiI18n.t("ui.address_not_found_325"));
      }
    } catch (error) {
      console.error('Error fetching geocode data:', error);
    }
  };
  
  const FitBounds = () => {
    const map = useMap();
    if (boundingBox) {
      map.fitBounds(boundingBox);
    }
    return null;
  };

  useEffect(() => {
    if (Ville && citiesCoordinates[Ville]) {
      const { lat, lng } = citiesCoordinates[Ville];
      setCoordinates({ lat, lng });
      setFormData((prevData) => ({
        ...prevData,
        Latitude: lat,
        Longitude: lng
      }));
    } else {
      setCoordinates({ lat: 34.802075, lng: 9.055876 }); // Default to a central point in Tunisia
    }
  }, [Ville]);

  const onChange = (e) => {
    //const boolean = e.target.value === "true" ? true : false;
    const value = e.target.value === "true" ? true : e.target.value === "false" ? false : e.target.value; 
    if (e.target.files) {
      setFormData((prevData) => ({
        ...prevData,
        images: e.target.files,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [e.target.id]: value,
      }));
    }
  };

  const createClick = async (event) => {
    event.preventDefault();
    try {
      const payload = { ...formData, Adresse: searchTerm, Chambres: chambres,
        SallesBains: sallesDeBain, Lits: lits, MaxGuests: voyageurs, Prix: price,
        OffreMonth: offerMonth, OffreWeek: offerWeek };
      await createVacation(payload, Array.from(images || []));
      toast.success(uiI18n.t("ui.listing_published"));
      navigate("/myAds");
    } catch (error) { toast.error(error.message); }
  };

  const onImagesChange = (imageNames) => {
    setFormData((prevData) => ({
      ...prevData,
      UrlImages: imageNames.join(','),
      images: imageNames
    }));
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-3xl">
      <h1 className="text-3xl text-center font-bold mb-8">{t('create_ad')}</h1>
      <form id='CreateVacation' onSubmit={createClick} className="space-y-6">
         {/*  section 1 Biens */} 
        {currentSection === 1 && (   
          <div className="mb-6">  
           <div className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-6">         
            <div>
              <p className="mt-4 text-lg font-semibold">{t('choose_property_type')} </p>
              <div className="mt-4 flex space-x-2">
                <button
                  type="button"
                  id="Category"
                  value="Appartement"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    vacationTypeKey(Category) === "entirePlace" ? "bg-white text-black" : "bg-slate-600 text-white"
                  }`}
                >
                   {t('entirePlace')}  
                </button>
                <button
                  type="button"
                  id="Category"
                  value="Maison"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    vacationTypeKey(Category) === "oneRoom" ? "bg-white text-black" : "bg-slate-600 text-white"
                  }`}
                >  
               {t('oneRoom')} 
                </button>
                <button
                  type="button"
                  id="Category"
                  value="commercial"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    vacationTypeKey(Category) === "sharedRoom" ? "bg-white text-black" : "bg-slate-600 text-white"
                  }`}
                >
                {t('sharedRoom')}
                </button> 
                                                  
              
              </div>
            </div>
          </div>
 
        
            {/* {title.trim().length > 0 && 
            ( */}
              <button 
                onClick={handleContinue} 
                className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md"
              >
                 {t('continue')}
              </button>
            {/* )} */}
          </div>
        )}

        {currentSection === 2 && (
          <div className="mb-6">
            <h3 className="mb-4 text-xl font-semibold">{t('options.description')}
            </h3>
            
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold"> {t('options.wifi')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Wifi"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Wifi ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('yes')} 
                </button>
                <button
                  type="button"
                  id="Wifi"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Wifi ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.tv')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="TV"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    TV ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="TV"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !TV ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
           
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold"> {t('options.cuisine')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Kitchen"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Kitchen ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('yes')} 
                </button>
                <button
                  type="button"
                  id="Kitchen"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Kitchen ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.lavelinge')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Washer"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Washer ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="Washer"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Washer ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
            
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold"> {t('options.Parking')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Parking"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Parking ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('yes')} 
                </button>
                <button
                  type="button"
                  id="Parking"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Parking ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.climatisation')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="AC"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    AC ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="AC"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !AC ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
           
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold"> {t('options.espacedetravail')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="workspace"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    workspace ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('yes')} 
                </button>
                <button
                  type="button"
                  id="workspace"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !workspace ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.picine')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Piscine"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Piscine ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="Piscine"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Piscine ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
            
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold"> {t('options.barbecue')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Barbecue"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Barbecue ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('yes')} 
                </button>
                <button
                  type="button"
                  id="Barbecue"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Barbecue ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.jardin')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Garden"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Garden ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="Garden"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Garden ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.accesauplage')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="BeachAccess"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    BeachAccess ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="BeachAccess"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !BeachAccess ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
            <div>
              <label className="block text-lg font-semibold">{t('options.camera')}</label>
              <div className="flex items-center space-x-4">
                <button
                  type="button"
                  id="Camera"
                  value="true"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    Camera ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                   {t('yes')}
                </button>
                <button
                  type="button"
                  id="Camera"
                  value="false"
                  onClick={onChange}
                  className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                    !Camera ? "bg-slate-600 text-white" : "bg-white text-black"
                  }`}
                >
                  {t('non')}
                </button>
              </div>
            </div>
          </div> 
          <button 
              onClick={handlePrevious} 
              className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
              {t('previous')}    
                         </button>
              <button 
              onClick={handleContinue} 
              className="mt-4 ms-2 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
             {t('continue')} 
            </button>
            
          </div> 
          
        )}

        {currentSection === 3 && (
          <div className="mb-6">
            <h3 className="mb-4 text-xl font-semibold">{t('maps')}</h3>
         
         
            {/* Adresse */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> 
         <div>

         </div>
          </div> 
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* @ et CP */} 
             <div>
             <label className="block text-lg font-semibold" htmlFor="Adresse">
               {t('address')}
              </label>
             <div className="flex items-center space-x-4"> 
            
              <input
              required
             type="text"
             value={searchTerm}
             id="Adresse" 
             onChange={(e) => setSearchTerm(e.target.value)}
             placeholder={t('enterAdres')}
             className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
            />
              <button
               onClick={handleSearch} 
             >
              <FaSearchLocation />
             </button>
   
            </div>
            <div>
              <label className="block text-lg font-semibold" htmlFor="CodePostal">
              {t('postal_code')} 
              </label>
              <input
                type="text"
                id="CodePostal"
                value={CodePostal}
                onChange={onChange}
                className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
              />
            </div>
            </div> 
             {/* Ville et Délégation */}
            <div>
               <div>
              <label className="block text-lg font-semibold" htmlFor="Ville">
              {t('city')} 
              </label>
              <select
              required
                id="Ville"
                value={Ville}
                onChange={(e) => {
                  onChange(e);
                  setFormData((prevData) => ({
                    ...prevData,
                    Delegation: "", // Réinitialiser la délégation lorsque la ville change
                  }));
                }}                className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
              >
                <option value="" disabled>{t('SelectCity')}</option>
                {Object.keys(citiesAndDelegations).map((ville) => (
              <option key={ville} value={ville}>
                {t(`cities.${ville}`)}
                </option>
            ))}
              </select>

              <label className="block text-lg font-semibold" htmlFor="Delegation">
              {t('delegation')}
              </label>
              <select
              required
                id="Delegation"
                value={Delegation}
                onChange={onChange}
                className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
              >
                {citiesAndDelegations[Ville]?.map((delegation) => (
                  <option key={delegation} value={delegation}>
                  {t(`delegations.${Ville}.${delegation}`)}
                  </option>
                ))}
              </select>

               </div>
            </div>
          </div>

         <div className="mt-2 grid grid-cols-1 md:grid-cols-1 gap-6"> 
           <MapContainer center={position} zoom={zoom} ref={mapRef} className="w-full h-[300px]"  >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={position}>
          <Popup>
          {Adresse}  <br />   {Ville}  <br />{Delegation}
          </Popup>
        </Marker>
        <FitBounds />
          </MapContainer>
          </div> 
            <button 
              onClick={handlePrevious} 
              className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
                           {t('previous')}    

            </button>
          {/* {Adresse.trim().length > 3 && ( */}
                <button 
              onClick={handleContinue} 
              className="mt-4 ms-2 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
             {t('continue')} 
             </button>
          {/* )}     */}
          </div>
        
        )} 

{currentSection === 4 && (
          <div className="mb-6">
           {/* <h3 className="mb-4 text-xl font-semibold">Coût</h3>  */}
          {[
          { label: t('lord'), value: voyageurs, setValue: setVoyageurs },
          { label: t('bedrooms')   , value: chambres, setValue: setChambres },
          { label: t('beds'), value: lits, setValue: setLits },
          { label: t('bathrooms'), value: sallesDeBain, setValue: setSallesDeBain }
        ].map((item, index) => (
          <div key={index} className="flex items-center justify-between mb-4">
            <span className="text-lg">{item.label}</span>
            <div className="flex items-center space-x-4">
              <button 
                onClick={(event) => {
                event.preventDefault();
                item.setValue(item.value > 0 ? item.value - 1 : 0)}  }
                className="bg-gray-200 p-2 rounded-full"
              >
                <span className="text-xl">-</span>
              </button>
              <span className="text-lg">{item.value}</span>
              <button 
                 onClick={(event) => {
                  event.preventDefault(); item.setValue(item.value + 1) }}
                className="bg-gray-200 p-2 rounded-full"
              >
                <span className="text-xl">+</span>
              </button>
            </div>
          </div>
        ))}
  
            <button 
              onClick={handlePrevious} 
              className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
                          {t('previous')}    

            </button>
            <button 
              onClick={handleContinue} 
              className="mt-4 ms-2 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
             {t('continue')} 
             </button>
          </div>
        )} 

        {currentSection === 5 && (
          <div className="mb-6">
          {/* Section */}
          <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
            <div className="flex items-center justify-between mb-4">
              <span className="text-lg font-semibold">{t('price')}</span>
              <div className="flex items-center w-full">
                <input
                  id="Prix"
                  type="range"
                  min="0"
                  max="5000"
                  step="5"
                  value={price}
                  onChange={handlePriceChange}
                  className="w-full h-5 ms-5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <span className="ms-4 text-3xl">{price} DT</span>
              </div>
            </div>
            <div className="flex items-center justify-between mb-4">
              <p className="text-lg mt-6 font-semibold"> {t('offer')}</p>
              <div className="flex mb-1">
                <button
                  type="button"
                  id="Offre"
                  value={true}
                  onClick={onChange}
                  className={`me-3 px-7 py-3 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg focus:shadow-lg active:shadow-lg transition duration-150 ease-in-out w-full ${Offre ? "bg-slate-600 text-white" : "bg-white text-black"}`}
                >
                  {t('yes')}
                </button>
                <button
                  type="button"
                  id="Offre"
                  value={false}
                  onClick={onChange}
                  className={`ms-3 px-7 py-3 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg focus:shadow-lg active:shadow-lg transition duration-150 ease-in-out w-full ${!Offre ? "bg-slate-600 text-white" : "bg-white text-black"}`}
                >
                  {t('non')}
                </button>
              </div>
              <div className="flex-initial mb-1">
                 {Offre && (
                 <div className="flex items-center justify-between mb-4">
                  {/* <label className="block text-lg font-semibold" htmlFor="PrixReduit">
                  {t('offer')}
               </label>   */}
                     <input
                      type="number"
                      id="PrixReduit"
                      value={PrixReduit}
                      onChange={onChange}
                      min="0"
                      max="50000000"
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center mb-1"
                    /> Dt
                  </div>
                  )} 
                  </div>
            </div>
            <div className="flex items-center justify-between mb-4">
              <span className="text-lg font-semibold">
              {t('SoldeW')}      <span className="text-sm text-gray-400">  {t('SoldeW_')}  </span>
              </span>
              <div className="flex items-center w-full">
                <input
                  id="offerWeek"
                  type="range"
                  min="0"
                  step="5"
                  max="100"
                  value={offerWeek}
                  onChange={handleOfferWeekChange}
                  className="w-1/4 ms-8 h-5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <span className="ms-4 text-green-700 text-xl">{offerWeek}%</span>
              </div>
            </div>
    
            <div className="flex items-center justify-between mb-4">
              <span className="text-lg font-semibold">
              {t('SoldeM')}      <span className="text-sm text-gray-400"> {t('SoldeM_')}</span>
              </span>
              <div className="flex items-center w-full">
                <input
                  id="offerMonth"
                  type="range"
                  min="0"
                  step="5"
                  max="100"
                  value={offerMonth}
                  onChange={handleOfferMonthChange}
                  className=" ms-10 w-1/4 h-5 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                />
                <span className="ms-4  text-green-700 text-xl">{offerMonth}%</span>
              </div>
            </div>
    
            <div className="flex">
              <button onClick={handlePrevious} className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md">
              {t('previous')}  
              </button>

              <button
              onClick={handleContinue}
              className="mt-4 ms-2 px-4 py-2 bg-gray-900 text-white rounded-md">
              {t('continue')} 
              </button>

            </div>
          </div>
        </div>
        )}

      {currentSection === 6 && (
          <div className="mb-6">
            <h3 className="mb-4 text-xl font-semibold">{t('Contacts')}</h3>
            {/* section contact*/}
          
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold" htmlFor="Email">
              {t('email')} 
              </label>
              <input
              required
                type="text"
                id="Email"
                value={Email}
                onChange={onChange}
                className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
              />
            </div>
            <div>
              <label className="block text-lg font-semibold" htmlFor="Tel">
              {t('numtel')}
              </label>
              <input
              required
                type="text"
                id="Tel"
                value={Tel}
                onChange={onChange}
                className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
              />
            </div>
          </div>  
            <button 
              onClick={handlePrevious} 
              className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md"
            >
                           {t('previous')}      
            </button>
           <button
              onClick={handleContinue}
              className="mt-4 ms-2 px-4 py-2 bg-gray-900 text-white rounded-md">
              {t('continue')} 
              </button>

          
          </div>
        )}         

        {currentSection === 7 && (
            <div className="mb-6">
              <h3 className="mb-4 text-xl font-semibold">{uiI18n.t("ui.upload_images_of_your_property")}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <ImageUpload onImagesChange={onImagesChange} />
                </div>
              </div>
              <button
                onClick={handlePrevious}
                className="mt-4 px-4 py-2 bg-gray-900 text-white rounded-md"
              >
                 {t('previous')}
              </button>
              
              <div className="text-center">
                <button
                  type="submit"
                  className="px-6 py-3 bg-gray-600 text-white font-semibold text-lg rounded shadow-md hover:bg-gray-700 transition duration-150 ease-in-out"
                >
                  {t('create_ad_button')}
                </button>
              </div>
            </div>
            
          )}
        </form>
      </div>
    </div>
  );
}

export default CreatePartyRooms;